import { render } from "./promised-eta.vue?vue&type=template&id=23af9f33"
import script from "./promised-eta.vue?vue&type=script&lang=js"
export * from "./promised-eta.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__